import React, { useState, useEffect, useContext } from "react";
import UserAppSurveyAlertReadOnlyRow from "./UserAppSurveyAlertReadOnlyRow";
import UserAppSurveyAlertTableRow from "./UserAppSurveyAlertTableRow";
import UserContext from "../contexts/UserContext";
import { useTranslation } from 'react-i18next';
import FetchUtil from "../utils/FetchUtil";
import "../css/ListUsers.css";
import { useNavigate } from "react-router-dom";

function UserAppSurveyAlertTable({ key, setAppSurveyAlert, loginId, companyId }) {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [add, setAdd] = useState(false);
    const [addRowTop, setAddRowTop] = useState(false);
    const [addRowBottom, setAddRowBottom] = useState(false);
    const [error, setError] = useState("");
    const [isUserAppSurveyAlertLoading, setIsUserAppSurveyAlertLoading] = useState(false);
    const [isAppSurveyNameLoading, setIsAppSurveyNameLoading] = useState(false);
    const [appSurveyNames, setAppSurveyNames] = useState([]);
    const [userAppSurveyAlerts, setUserAppSurveyAlerts] = useState([]);
    const [count, setCount] = useState(0);
    const closeText = t("page.close");
    const userCtx = useContext(UserContext);

    const initialValues = {
        loginId: loginId,
        companyId: companyId,
        appSurveyKey: 0,
        notCompleted: false,
        completed: false,
        highScore: false,
        takeCorrectiveAction: false,
        completedCorrectiveAction: false
    };
    const [formValues, setFormValues] = useState(initialValues);

    const resetCounter = () => {
        setCount(prevCount => prevCount + 1);
    };

    let userCompanyId = (userCtx.role !== "SiteAdmin") ? userCtx.userCompanyId : 0;
    useEffect(() => {
        fetchAppSurveyNames();
        fetchUserAppSurveyAlerts();
    }, []);

    const handleClose = (event) => {
        setAppSurveyAlert(false);
    };

    function fetchAppSurveyNames() {
        setError("");
        setIsAppSurveyNameLoading(true);
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                source: "web", getAll: false
            }),
        };
        try {
            FetchUtil.fetchAPI("GetAppSurveyNames", "/Service/StaticHelper/GetAppSurveyNames", requestOptions, retrieveAppSurveyNameSuccess, retrieveAppSurveyNameFail);
        } catch (error) {
            setIsAppSurveyNameLoading(false);
            throw new Error(error.message);
        }
    }

    function retrieveAppSurveyNameFail(redirect) {
        setIsAppSurveyNameLoading(false);
        if (redirect) {
            navigate("/");
        }
        setError(t("error.getAppSurveyFailed"));
    }

    function retrieveAppSurveyNameSuccess(responseData) {
        let getAppSurveyNameResponse;
        if (responseData) {
            getAppSurveyNameResponse = responseData.getAppSurveyNameResponse;
            if (getAppSurveyNameResponse && getAppSurveyNameResponse.errorCode === "0") {
                setAppSurveyNames(getAppSurveyNameResponse.appSurveyList.slice())
            } else if (getAppSurveyNameResponse && getAppSurveyNameResponse.errorCode === "114") {
                navigate("/", {
                    state: {
                        errorMessage: t("error.sessionTimeout"),
                    },
                });
            } else if (getAppSurveyNameResponse) {
                setError(t("error.error") + " " + getAppSurveyNameResponse.errorMessage);
            } else {
                setError(t("error.system.fetch"));
            }
        }
        setIsAppSurveyNameLoading(false);
    }

    function fetchUserAppSurveyAlerts() {
        setError("");
        if (!initialValues.companyId || initialValues.companyId === 0 || !initialValues.loginId) {
            return;
        }
        resetCounter();
        setIsUserAppSurveyAlertLoading(true);
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                source: "web", getAll: true, companyId: initialValues.companyId,
                loginId: initialValues.loginId, userCompanyId: userCompanyId
            }),
        };
        try {
            FetchUtil.fetchAPI("GetUserAppSurveyAlert", "/Service/UserService/GetUserAppSurveyAlert", requestOptions, retrieveUserAppSurveyAlertSuccess, retrieveUserAppSurveyAlertFail);
        } catch (error) {
            setIsUserAppSurveyAlertLoading(false);
            throw new Error(error.message);
        }
    }

    function retrieveUserAppSurveyAlertFail(redirect) {
        setIsUserAppSurveyAlertLoading(false);
        if (redirect) {
            navigate("/");
        }
        setError(t("error.userGetSurveyAlertFailed"));
    }

    function retrieveUserAppSurveyAlertSuccess(responseData) {
        let fetchUserAppSurveyAlertsResponse;
        if (responseData) {
            fetchUserAppSurveyAlertsResponse = responseData.fetchUserAppSurveyAlertsResponse;
            if (fetchUserAppSurveyAlertsResponse && fetchUserAppSurveyAlertsResponse.errorCode === "0") {
                setUserAppSurveyAlerts(fetchUserAppSurveyAlertsResponse.appSurveyAlertList.slice())
            } else if (fetchUserAppSurveyAlertsResponse && fetchUserAppSurveyAlertsResponse.errorCode === "114") {
                navigate("/", {
                    state: {
                        errorMessage: t("error.sessionTimeout"),
                    },
                });
            } else if (fetchUserAppSurveyAlertsResponse) {
                setError(t("error.error") + " " + fetchUserAppSurveyAlertsResponse.errorMessage);
            } else {
                setError(t("error.system.fetch"));
            }
        }
        setIsUserAppSurveyAlertLoading(false);
    }

    const handleDeleteClick = (event, userAppSurveyItem, completeCallback) => {
        event.preventDefault();
        deleteUserAppSurveyAlert(userAppSurveyItem, completeCallback);
    };
    const deleteUserAppSurveyAlert = (userAppSurveyItem, completeCallback) => {
        let action = 3;
        if (userAppSurveyItem.statusCode === 1) {
            action = 4;
        }
        let serverParams = {
            loginId: formValues.loginId,
            appSurveyKey: userAppSurveyItem.appSurveyKey,
            userCompanyId: userCompanyId,
            source: "web",
            action: action
        };
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(serverParams),
        };

        try {
            FetchUtil.fetchAPI("DeleteUserAppSurveyAlert", "/Service/UserService/DeleteUserAppSurveyAlert", requestOptions, deleteUserAppSurveyAlertSuccess, deleteUserAppSurveyAlertFail, completeCallback);
        } catch (error) {
            setError(error.message);
            if (completeCallback) {
                completeCallback();
            }
        }
    };

    function deleteUserAppSurveyAlertFail(redirect, completeCallback) {
        setError(t("error.userSurveyAlertEditFailed"));
        if (completeCallback) {
            completeCallback();
        }
    }
    function deleteUserAppSurveyAlertSuccess(responseData, completeCallback) {
        let deleteUserAppSurveyAlertResponse;
        if (responseData) {
            deleteUserAppSurveyAlertResponse = responseData.deleteUserAppSurveyAlertResponse;
            if (deleteUserAppSurveyAlertResponse) {
                if (deleteUserAppSurveyAlertResponse.errorCode === "0") {
                    resetRowTable();
                    refreshUserAppSurveyAlert();
                } else {
                    setError(t("error.error") + " " +
                        deleteUserAppSurveyAlertResponse.errorMessage
                    );
                }
            }
        }
        if (completeCallback) {
            completeCallback();
        }
    }
    const addRowTableTop = () => {
        setAddRowTop(true);
        setAddRowBottom(false);
        addRowTable();
    };

    const addRowTableBottom = () => {
        setAddRowTop(false);
        setAddRowBottom(true);
        addRowTable();
    };
    const addRowTable = () => {
        setError("");
        if (!add) {
            setAdd(true);
        } else {
            setError(t("error.only1RowAllowed"));
        }

    };
    const removeRowTable = () => {
        setError("");
        resetRowTable();
    };
    const resetRowTable = () => {
        setAddRowTop(false);
        setAddRowBottom(false);
        setAdd(false);
    };
    const handleSubmit = (action, setValues, completeCallback) => {
        setError("");
        let found = false;
        if (!formValues.loginId) {
            setError(t("error.userReqd"));
            if (completeCallback) {
                completeCallback();
            }
            return false;
        }
        if (action === 1) {
            if (userAppSurveyAlerts.length > 0) {
                userAppSurveyAlerts.map((userAppSurveyItem, index) => {
                    if (userAppSurveyItem.appSurveyKey === setValues.appSurveyKey) {
                        setError(t("error.userSurveyAlertDup"));
                        found = true;
                        if (completeCallback) {
                            completeCallback();
                        }
                        return false;
                    }
                })
            }
            if (!found) {
                saveUserAppSurveyAlert(action, setValues, completeCallback);
            } else {
                if (completeCallback) {
                    completeCallback();
                }
            }
        } else if (action === 2) {
            if (userAppSurveyAlerts.length > 0) {
                userAppSurveyAlerts.map((userAppSurveyItem, index) => {
                    if (userAppSurveyItem.appSurveyKey === setValues.appSurveyKey) {
                        found = true;
                    }
                })
            }
            if (found) {
                saveUserAppSurveyAlert(action, setValues, completeCallback);
            } else {
                if (completeCallback) {
                    completeCallback();
                }
            }
        } else if (completeCallback) {
            completeCallback();
        }
    };
    const saveUserAppSurveyAlert = (action, setValues, completeCallback) => {
        let serverParams = {
            loginId: formValues.loginId,
            companyId: formValues.companyId,
            userCompanyId: userCompanyId,
            appSurveyKey: setValues.appSurveyKey,
            notCompleted: setValues.notCompleted,
            completed: setValues.completed,
            highScore: setValues.highScore,
            dayOfWeek: setValues.dayOfWeek,
            weekly: setValues.weekly,
            monthly: setValues.monthly,
            yearly: setValues.yearly,
            takeCorrectiveAction: setValues.takeCorrectiveAction,
            completedCorrectiveAction: setValues.completedCorrectiveAction,
            source: "web",
            action: action
        };

        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(serverParams),
        };

        try {
            FetchUtil.fetchAPI("AddUpdateUserAppSurveyAlert", "/Service/UserService/AddUpdateUserAppSurveyAlert", requestOptions, saveUserAppSurveyAlertSuccess, saveUserAppSurveyAlertFail, completeCallback);
        } catch (error) {
            setError(error.message);
            if (completeCallback) {
                completeCallback();
            }
        }
    };

    function saveUserAppSurveyAlertFail(redirect, completeCallback) {
        setError(t("error.userSurveyAlertEditFailed"));
        if (completeCallback) {
            completeCallback();
        }
    }
    function saveUserAppSurveyAlertSuccess(responseData, completeCallback) {
        let addUpdateUserAppSurveyAlertResponse;
        if (responseData) {
            addUpdateUserAppSurveyAlertResponse = responseData.addUpdateUserAppSurveyAlertResponse;
            if (addUpdateUserAppSurveyAlertResponse) {
                if (addUpdateUserAppSurveyAlertResponse.errorCode === "0") {
                    resetRowTable();
                    refreshUserAppSurveyAlert();
                } else {
                    setError(t("error.error") + " " +
                        addUpdateUserAppSurveyAlertResponse.errorMessage
                    );
                }
            }
        }
        if (completeCallback) {
            completeCallback();
        }
    }
    function refreshUserAppSurveyAlert() {
        fetchUserAppSurveyAlerts();
    }
    return (
        <>
            {(userCtx.role === "SiteAdmin" || userCtx.role === "ClientAdmin") ?
                <div className="container-fluid container_list_sm viewh-85">
                    <div className="row">
                        <div className="col mt-3">
                            {(error) ? (
                                <div id="inerrorMessage" className="errorblock">
                                    {error}
                                </div>
                            ) : (<></>)}
                        </div>
                        {(isUserAppSurveyAlertLoading || isAppSurveyNameLoading) && (<div> <span class="spinner-border spinner-border-sm spinner-lg-size"></span> </div>)}
                    </div>
                    <div className="row" style={{ margin: "0px" }}>
                        <div className="col">
                            <a class="popup-close" id="boxclose" onClick={(e) => handleClose(e)} ></a>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div id="placeholder_1" className="placeholder-pg"></div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <table className="list-table" role="table">
                                <thead>
                                    <tr role="row">
                                        <th className="list-th" style={{ maxWidth: "15vw" }}>{t("page.survey.name")}</th>
                                        <th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.freq")}</th>
                                        <th className="list-th" style={{ maxWidth: "9vw" }}>{t("page.dow")}</th>
                                        <th className="list-th" style={{ maxWidth: "9vw" }}>{t("page.alert.notcomplete")}</th>
                                        <th className="list-th" style={{ maxWidth: "9vw" }}>{t("page.alert.complete")}</th>
                                        <th className="list-th" style={{ maxWidth: "9vw" }}>{t("page.alert.highscore")}</th>
                                        <th className="list-th" style={{ maxWidth: "8vw" }}>{t("page.take.corr.action")}</th>
                                        <th className="list-th" style={{ maxWidth: "8vw" }}>{t("page.completed.corr.action")}</th>
                                        <th className="list-th" style={{ maxWidth: "8vw" }}>{t("page.status")}</th>
                                        <th className="list-th" style={{ maxWidth: "15vw" }}>
                                            <button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableTop}>
                                                {t("page.addRow")}
                                            </button>&nbsp;&nbsp;
                                            <button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
                                                {t("page.delRow")}
                                            </button>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody role="rowgroup">
                                    {add && addRowTop &&
                                        <UserAppSurveyAlertTableRow
                                            index={count}
                                            appSurveyNames={appSurveyNames}
                                            handleSubmit={handleSubmit}
                                            setError={setError}
                                            t={t}
                                            setAdd={setAdd}
                                            oddIdx={((userAppSurveyAlerts.length % 2) > 0) ? true : false} />
                                    }
                                    {(userAppSurveyAlerts.length > 0) ? (
                                        userAppSurveyAlerts.map((userAppSurveyItem, index) => (
                                            <UserAppSurveyAlertReadOnlyRow
                                                index={count}
                                                t={t}
                                                userAppSurveyAlertItem={userAppSurveyItem}
                                                handleDeleteClick={handleDeleteClick}
                                                oddIdx={((index % 2) > 0) ? true : false}
                                                add={add}
                                                setError={setError}
                                                handleSubmit={handleSubmit}
                                            />
                                        ))
                                    ) : (<></>)}
                                    {add && addRowBottom &&
                                        <UserAppSurveyAlertTableRow
                                            index={count}
                                            appSurveyNames={appSurveyNames}
                                            handleSubmit={handleSubmit}
                                            setError={setError}
                                            t={t}
                                            setAdd={setAdd}
                                            oddIdx={((userAppSurveyAlerts.length % 2) > 0) ? true : false} />
                                    }
                                </tbody>
                                {(userAppSurveyAlerts.length > 10) ? (<tfoot>
                                    <tr role="row">
                                        <th className="list-th" style={{ maxWidth: "15vw" }}>{t("page.survey.name")}</th>
                                        <th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.freq")}</th>
                                        <th className="list-th" style={{ maxWidth: "9vw" }}>{t("page.dow")}</th>
                                        <th className="list-th" style={{ maxWidth: "9vw" }}>{t("page.alert.notcomplete")}</th>
                                        <th className="list-th" style={{ maxWidth: "9vw" }}>{t("page.alert.complete")}</th>
                                        <th className="list-th" style={{ maxWidth: "9vw" }}>{t("page.alert.highscore")}</th>
                                        <th className="list-th" style={{ maxWidth: "8vw" }}>{t("page.take.corr.action")}</th>
                                        <th className="list-th" style={{ maxWidth: "8vw" }}>{t("page.completed.corr.action")}</th>
                                        <th className="list-th" style={{ maxWidth: "8vw" }}>{t("page.status")}</th>
                                        <th className="list-th" style={{ maxWidth: "15vw" }}>
                                            <button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableBottom}>
                                                {t("page.addRow")}
                                            </button>&nbsp;&nbsp;
                                            <button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
                                                {t("page.delRow")}
                                            </button>
                                        </th>
                                    </tr>
                                </tfoot>
                                ) : (<></>)}
                            </table>
                            <div className="row">
                                <div className="col mt-3">
                                    {(error) ? (
                                        <div id="inerrorMessage1" className="errorblock">
                                            {error}
                                        </div>
                                    ) : (<></>)}
                                </div>
                            </div>
                            <div className="footer">
                                <input
                                    type="button"
                                    name="edit-user-appsurvey-close"
                                    id="edit-user-appsurvey-close"
                                    className="btn btn-secondary btn-block" data-dismiss="modal"
                                    onClick={(e) => handleClose(e)}
                                    style={{ marginTop: "10px", marginBottom: "10px" }}
                                    value={closeText}
                                ></input>
                            </div>
                        </div>
                    </div>
                </div>
                : null}
        </>
    );
}
export default UserAppSurveyAlertTable;